export const GET_CITIES = 'city/GET_CITIES';
export const GET_CITIES_SUCCESS = 'city/GET_CITIES_SUCCESS';
export const GET_CITIES_ERROR = 'city/GET_CITIES_ERROR';
